import React, { ReactElement } from "react";
import styled from "styled-components";
import { ChartData } from "@lifeat/shared/data-models/user/UserMetrics/UserMetricsEntity";
import { FontSize } from "@themes/Fonts";
import Styles from "@themes/Styles";
import BarChart from "./BarChart";

const ChartWrapper = styled.div`
    margin: 15px;
`;

const Chart = styled.div`
    background-color: ${(props) => props.theme.backgroundSpecial};
    border-radius: ${Styles.borderRadiusNormal};
    overflow: hidden;
    margin: 10px 0;
    width: 100%;
`;

const ChartHeader = styled.div`
    padding-top: 15px;
    padding-left: 20px;
    font-size: ${FontSize.small};
    color: ${(props) => props.theme.textColorPrimary};
`;

interface UserMetricChartProps {
    readonly title: string;
    readonly numDays: number;
    readonly data: ChartData;
    readonly hide?: boolean;
    readonly alternateContent?: ReactElement;
}

export default function UserMetricChart(props: UserMetricChartProps) {
    const chart = (
        <>
            <ChartHeader>{props.title}</ChartHeader>
            <ChartWrapper className={`user-metrics-chart-wrapper`}>
                <BarChart numDays={props.numDays} data={props.data} />
            </ChartWrapper>
        </>
    );

    return <Chart className={`user-metrics-chart`}>{props.hide ? props.alternateContent : chart}</Chart>;
}
